import React from 'react'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'

const Start = ({ data: props }) => {

    return (
        <>
            <HeaderTitle noHr size={'fs-3'} title={'Start'} />

            <div className={'d-flex flex-column gap-3'}>
                <InputWiz wiz={props.wiz} disabled keyName={'rejestr_numer'} />
                <InputWiz wiz={props.wiz} disabled keyName={'numer'} />
                <InputWiz wiz={props.wiz} disabled keyName={'tytul'} />
                <InputWiz wiz={props.wiz} disabled keyName={'kategoria'} />
                <InputWiz wiz={props.wiz} disabled keyName={'podmiot'} />
            </div>
        </>
    )
}

export default Start
